import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import ReactHtmlParser from 'react-html-parser';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';
import Link from '../../../Core/Link';

import { ContentWrapper, Article, Ctas } from './styles';

const link = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
  },
};

const FAQBlock = ({ data }) => {
  if (!data) return null;

  const { elements, component, sectionContainerHeading, ctas } = data;

  return (
    <Container as="section" id="faqs">
      {/* Map and print out straight text content (FAQs) */}
      <ContentWrapper className={component}>
        <RichText document={sectionContainerHeading} />
        {elements.map(
          ({ id, googleAnalyticTagId, paragraphCopy, paragraphHeading }) => {
            return (
              <Article key={id} id={googleAnalyticTagId}>
                {ReactHtmlParser(paragraphHeading.childMarkdownRemark.html)}
                <div>
                  {ReactHtmlParser(paragraphCopy.childMarkdownRemark.html)}
                </div>
              </Article>
            );
          },
        )}
      </ContentWrapper>
      {ctas && (
        <Ctas>
          {ctas.map(cta => {
            if (cta.hideFrench === true) return null;
            return (
              <Link key={cta.id} data={cta}>
                <RichText document={cta.label} options={link} />
              </Link>
            );
          })}
        </Ctas>
      )}
    </Container>
  );
};

FAQBlock.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FAQBlock;
